export default __webpack_public_path__ + "static/media/sub12_v2.21255865.png";